export const faces_emoji = [
        "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😂",
      "🙂",
      "🙃",
      "🫠",
      "😉",
      "😊",
      "😇",
      "🥰",
      "😍",
      "🤩",
      "😘",
      "😗",
      "☺️",
      "😚",
      "😙",
      "🥲",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🫢",
      "🫣",
      "🤫",
      "🤔",
      "🫡",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "🫥",
      "😏",
      "😒",
      "🙄",
      "😬",
      "🤥",
      "🫨",
      "😌",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🤧",
      "🥵",
      "🥶",
      "🥴",
      "😵",
      "🤯",
      "🤠",
      "🥳",
      "🥸",
      "😎",
      "🤓",
      "🧐",
      "😕",
      "🫤",
      "😟",
      "🙁",
      "☹️",
      "😮",
      "😯",
      "😲",
      "😳",
      "🥺",
      "🥹",
      "😦",
      "😧",
      "😨",
      "😰",
      "😥",
      "😢",
      "😭",
      "😱",
      "😖",
      "😣",
      "😞",
      "😓",
      "😩",
      "😫",
      "🥱",
      "😤",
      "😡",
      "😠",
      "🤬",
      "😈",
      "👿",
      "💀",
      "☠️",
      "💩",
      "🤡",
      "👹",
      "👺",
      "👻",
      "👽",
      "👾",
      "🤖",
      "😺",
      "😸",
      "😹",
      "😻",
      "😼",
      "😽",
      "🙀",
      "😿",
      "😾",
      "🙈",
      "🙉",
      "🙊",
      "💌",
      "💘",
      "💝",
      "💖",
      "💗",
      "💓",
      "💞",
      "💕",
      "💟",
      "❣️",
      "💔",
      "❤️",
      "🩷",
      "🧡",
      "💛",
      "💚",
      "💙",
      "🩵",
      "💜",
      "🤎",
      "🖤",
      "🩶",
      "🤍",
      "💋",
      "💯",
      "💢",
      "💥",
      "💫",
      "💦",
      "💨",
      "🕳️",
      "💬",
      "👁️‍🗨️",
      "🗨️",
      "🗯️",
      "💭",
      "💤",
      "👋",
      "🤚",
      "🖐️",
      "✋",
      "🖖",
      "🫱",
      "🫲",
      "🫳",
      "🫴",
      "🫷",
      "🫸",
      "👌",
      "🤌",
      "🤏",
      "✌️",
      "🤞",
      "🫰",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝️",
      "🫵",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "🫶",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍️",
      "💅",
      "🤳",
      "💪",
      "🦾",
      "🦿",
      "🦵",
      "🦶",
      "👂",
      "🦻",
      "👃",
      "🧠",
      "🫀",
      "🫁",
      "🦷",
      "🦴",
      "👀",
      "👁️",
      "👅",
      "👄",
      "🫦",
      "👶",
      "👦",
      "👧",
      "👨",
      "👨‍🦳",
      "👩",
      "👴",
      "👵",
      "👨‍⚕️",
      "👩‍⚕️",
      "👨‍🎓",
      "👩‍🎓",
      "👨‍🏫",
      "👩‍🏫",
      "👨‍⚖️",
      "👩‍⚖️",
      "👨‍🌾",
      "👩‍🌾",
      "👨‍🍳",
      "👩‍🍳",
      "👨‍🔧",
      "👩‍🔧",
      "👨‍🏭",
      "👩‍🏭",
      "👨‍💼",
      "👩‍💼",
      "👨‍🔬",
      "👩‍🔬",
      "👨‍💻",
      "👩‍💻",
      "👨‍🎤",
      "👩‍🎤",
      "👨‍🎨",
      "👩‍🎨",
      "👨‍✈️",
      "👩‍✈️",
      "👨‍🚀",
      "👩‍🚀",
      "👨‍🚒",
      "👩‍🚒",
      "🥷",
      "🤴",
      "👸",
      "🧕",
      "🤰",
      "👼",
      "🎅",
      "🧌",
      "💃",
      "🕺",
      "👫",
      "🗣️",
      "👤",
      "👥",
      "🫂",
      "👪",
      "👣",
      "🎃",
      "🎄",
      "🎆",
      "🎇",
      "🧨",
      "✨",
      "🎈",
      "🎉",
      "🎊",
      "🎋",
      "🎍",
      "🎎",
      "🎏",
      "🎐",
      "🎑",
      "🧧",
      "🎀",
      "🎁",
      "🎗️",
      "🎟️",
      "🎫",
];
export const animals_emoji = [
        "🐵",
      "🐒",
      "🦍",
      "🦧",
      "🐶",
      "🐕",
      "🦮",
      "🐩",
      "🐺",
      "🦊",
      "🦝",
      "🐱",
      "🐈",
      "🦁",
      "🐯",
      "🐅",
      "🐆",
      "🐴",
      "🫎",
      "🫏",
      "🐎",
      "🦄",
      "🦓",
      "🦌",
      "🦬",
      "🐮",
      "🐂",
      "🐃",
      "🐄",
      "🐷",
      "🐖",
      "🐗",
      "🐽",
      "🐏",
      "🐑",
      "🐐",
      "🐪",
      "🐫",
      "🦙",
      "🦒",
      "🐘",
      "🦣",
      "🦏",
      "🦛",
      "🐭",
      "🐁",
      "🐀",
      "🐹",
      "🐰",
      "🐇",
      "🐿️",
      "🦫",
      "🦔",
      "🦇",
      "🐻",
      "🐨",
      "🐼",
      "🦥",
      "🦦",
      "🦨",
      "🦘",
      "🦡",
      "🐾",
      "🦃",
      "🐔",
      "🐓",
      "🐣",
      "🐤",
      "🐥",
      "🐦",
      "🐧",
      "🕊️",
      "🦅",
      "🦆",
      "🦢",
      "🦉",
      "🦤",
      "🪶",
      "🦩",
      "🦚",
      "🦜",
      "🪽",
      "🪿",
      "🐸",
      "🐊",
      "🐢",
      "🦎",
      "🐍",
      "🐲",
      "🐉",
      "🦕",
      "🦖",
      "🐳",
      "🐋",
      "🐬",
      "🦭",
      "🐟",
      "🐠",
      "🐡",
      "🦈",
      "🐙",
      "🐚",
      "🪸",
      "🪼",
      "🦀",
      "🦞",
      "🦐",
      "🦑",
      "🦪",
      "🐌",
      "🦋",
      "🐛",
      "🐜",
      "🐝",
      "🪲",
      "🐞",
      "🦗",
      "🪳",
      "🕷️",
      "🕸️",
      "🦂",
      "🦟",
      "🪰",
      "🪱",
      "🦠",
      "💐",
      "🌸",
      "💮",
      "🪷",
      "🏵️",
      "🌹",
      "🥀",
      "🌺",
      "🌻",
      "🌼",
      "🌷",
      "🪻",
      "🌱",
      "🪴",
      "🌲",
      "🌳",
      "🌴",
      "🌵",
      "🌾",
      "🌿",
      "☘️",
      "🍀",
      "🍁",
      "🍂",
      "🍃",
      "🪹",
      "🪺",
      "🍄",
      "🌑",
      "🌒",
      "🌓",
      "🌔",
      "🌕",
      "🌖",
      "🌗",
      "🌘",
      "🌙",
      "🌚",
      "🌛",
      "🌜",
      "🌡️",
      "☀️",
      "🌝",
      "🌞",
      "🪐",
      "⭐",
      "🌟",
      "🌠",
      "🌌",
      "☁️",
      "⛅",
      "⛈️",
      "🌤️",
      "🌥️",
      "🌦️",
      "🌧️",
      "🌨️",
      "🌩️",
      "🌪️",
      "🌫️",
      "🌬️",
      "🌀",
      "🌈",
      "🌂",
      "☂️",
      "☔",
      "⛱️",
      "⚡",
      "❄️",
      "☃️",
      "⛄",
      "☄️",
      "🔥",
      "💧",
      "🌊",
]
export const fruits_emoji = [
        "🍇",
      "🍈",
      "🍉",
      "🍊",
      "🍋",
      "🍌",
      "🍍",
      "🥭",
      "🍎",
      "🍏",
      "🍐",
      "🍑",
      "🍒",
      "🍓",
      "🫐",
      "🥝",
      "🍅",
      "🫒",
      "🥥",
      "🥑",
      "🍆",
      "🥔",
      "🥕",
      "🌽",
      "🌶️",
      "🫑",
      "🥒",
      "🥬",
      "🥦",
      "🧄",
      "🧅",
      "🥜",
      "🫘",
      "🌰",
      "🫚",
      "🫛",
      "🍞",
      "🥐",
      "🥖",
      "🫓",
      "🥨",
      "🥯",
      "🥞",
      "🧇",
      "🧀",
      "🍖",
      "🍗",
      "🥩",
      "🥓",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🫔",
      "🥙",
      "🧆",
      "🥚",
      "🍳",
      "🥘",
      "🍲",
      "🫕",
      "🥣",
      "🥗",
      "🍿",
      "🧈",
      "🧂",
      "🥫",
      "🍱",
      "🍘",
      "🍙",
      "🍚",
      "🍛",
      "🍜",
      "🍝",
      "🍠",
      "🍢",
      "🍣",
      "🍤",
      "🍥",
      "🥮",
      "🍡",
      "🥟",
      "🥠",
      "🥡",
      "🍦",
      "🍧",
      "🍨",
      "🍩",
      "🍪",
      "🎂",
      "🍰",
      "🧁",
      "🥧",
      "🍫",
      "🍬",
      "🍭",
      "🍮",
      "🍯",
      "🍼",
      "🥛",
      "☕",
      "🫖",
      "🍵",
      "🍶",
      "🍾",
      "🍷",
      "🍸",
      "🍹",
      "🍺",
      "🍻",
      "🥂",
      "🥃",
      "🫗",
      "🥤",
      "🧋",
      "🧃",
      "🧉",
      "🧊",
      "🥢",
      "🍽️",
      "🍴",
      "🥄",
      "🔪",
      "🫙",
      "🏺",
]
export const activities_emoji = [
        "🎖️",
      "🏆",
      "🏅",
      "🥇",
      "🥈",
      "🥉",
      "⚽",
      "⚾",
      "🥎",
      "🏀",
      "🏐",
      "🏈",
      "🏉",
      "🎾",
      "🥏",
      "🎳",
      "🏏",
      "🏑",
      "🏒",
      "🥍",
      "🏓",
      "🏸",
      "🥊",
      "🥋",
      "🥅",
      "⛳",
      "⛸️",
      "🎣",
      "🤿",
      "🎽",
      "🎿",
      "🛷",
      "🥌",
      "🎯",
      "🪀",
      "🪁",
      "🔫",
      "🎱",
      "🔮",
      "🪄",
      "🎮",
      "🕹️",
      "🎰",
      "🎲",
      "🧩",
      "🧸",
      "🪅",
      "🪩",
      "🪆",
      "♠️",
      "♥️",
      "♦️",
      "♣️",
      "♟️",
      "🃏",
      "🀄",
      "🎴",
      "🎭",
      "🖼️",
      "🎨",
      "🧵",
      "🪡",
      "🧶",
      "🪢",
]
export const travel_emoji = [
        "🚂",
      "🚃",
      "🚄",
      "🚅",
      "🚆",
      "🚇",
      "🚈",
      "🚉",
      "🚊",
      "🚝",
      "🚞",
      "🚋",
      "🚌",
      "🚍",
      "🚎",
      "🚐",
      "🚑",
      "🚒",
      "🚓",
      "🚔",
      "🚕",
      "🚖",
      "🚗",
      "🚘",
      "🚙",
      "🛻",
      "🚚",
      "🚛",
      "🚜",
      "🏎️",
      "🏍️",
      "🛵",
      "🦽",
      "🦼",
      "🛺",
      "🚲",
      "🛴",
      "🛹",
      "🛼",
      "🚏",
      "🛣️",
      "🛤️",
      "🛢️",
      "⛽",
      "🛞",
      "🚨",
      "🚥",
      "🚦",
      "🛑",
      "🚧",
      "⚓",
      "🛟",
      "⛵",
      "🛶",
      "🚤",
      "🛳️",
      "⛴️",
      "🛥️",
      "🚢",
      "✈️",
      "🛩️",
      "🛫",
      "🛬",
      "🪂",
      "💺",
      "🚁",
      "🚟",
      "🚠",
      "🚡",
      "🛰️",
      "🚀",
      "🛸",
      "🛎️",
      "🧳",
      "⌛",
      "⏳",
      "⌚",
      "⏰",
      "⏱️",
      "⏲️",
      "🕰️",
      "🕛",
      "🕧",
      "🕐",
      "🕜",
      "🕑",
      "🕝",
      "🕒",
      "🕞",
      "🕓",
      "🕟",
      "🕔",
      "🕠",
      "🕕",
      "🕡",
      "🕖",
      "🕢",
      "🕗",
      "🕣",
      "🕘",
      "🕤",
      "🕙",
      "🕥",
      "🕚",
      "🕦",
      "🌍",
      "🌎",
      "🌏",
      "🌐",
      "🗺️",
      "🗾",
      "🧭",
      "🏔️",
      "⛰️",
      "🌋",
      "🗻",
      "🗿",
      "🏕️",
      "🏖️",
      "🏜️",
      "🏝️",
      "🏞️",
      "🏟️",
      "🏛️",
      "🏗️",
      "🧱",
      "🪨",
      "🪵",
      "🛖",
      "🏘️",
      "🏚️",
      "🏠",
      "🏡",
      "🏢",
      "🏣",
      "🏤",
      "🏥",
      "🏦",
      "🏨",
      "🏩",
      "🏪",
      "🏫",
      "🏬",
      "🏭",
      "🏯",
      "🏰",
      "💒",
      "🗼",
      "🗽",
      "⛪",
      "🕌",
      "🛕",
      "🕍",
      "⛩️",
      "🕋",
      "⛲",
      "⛺",
      "🌁",
      "🌃",
      "🏙️",
      "🌄",
      "🌅",
      "🌆",
      "🌇",
      "🌉",
      "♨️",
      "🎠",
      "🛝",
      "🎡",
      "🎢",
      "💈",
      "🎪",
]
export const objects_emoji = [
        "👓",
      "🕶️",
      "🥽",
      "🥼",
      "🦺",
      "👔",
      "👕",
      "👖",
      "🧣",
      "🧤",
      "🧥",
      "🧦",
      "👗",
      "👘",
      "🥻",
      "🩱",
      "🩲",
      "🩳",
      "👙",
      "👚",
      "🪭",
      "👛",
      "👜",
      "👝",
      "🛍️",
      "🎒",
      "🩴",
      "👞",
      "👟",
      "🥾",
      "🥿",
      "👠",
      "👡",
      "🩰",
      "👢",
      "🪮",
      "👑",
      "👒",
      "🎩",
      "🎓",
      "🧢",
      "🪖",
      "⛑️",
      "📿",
      "💄",
      "💍",
      "💎",
      "🔇",
      "🔈",
      "🔉",
      "🔊",
      "📢",
      "📣",
      "📯",
      "🔔",
      "🔕",
      "🎼",
      "🎵",
      "🎶",
      "🎙️",
      "🎚️",
      "🎛️",
      "🎤",
      "🎧",
      "📻",
      "🎷",
      "🪗",
      "🎸",
      "🎹",
      "🎺",
      "🎻",
      "🪕",
      "🥁",
      "🪘",
      "🪇",
      "🪈",
      "📱",
      "📲",
      "☎️",
      "📞",
      "📟",
      "📠",
      "🔋",
      "🪫",
      "🔌",
      "💻",
      "🖥️",
      "🖨️",
      "⌨️",
      "🖱️",
      "🖲️",
      "💽",
      "💾",
      "💿",
      "📀",
      "🧮",
      "🎥",
      "🎞️",
      "📽️",
      "🎬",
      "📺",
      "📷",
      "📸",
      "📹",
      "📼",
      "🔍",
      "🔎",
      "🕯️",
      "💡",
      "🔦",
      "🏮",
      "🪔",
      "📔",
      "📕",
      "📖",
      "📗",
      "📘",
      "📙",
      "📚",
      "📓",
      "📒",
      "📃",
      "📜",
      "📄",
      "📰",
      "🗞️",
      "📑",
      "🔖",
      "🏷️",
      "💰",
      "🪙",
      "💴",
      "💵",
      "💶",
      "💷",
      "💸",
      "💳",
      "🧾",
      "💹",
      "✉️",
      "📧",
      "📨",
      "📩",
      "📤",
      "📥",
      "📦",
      "📫",
      "📪",
      "📬",
      "📭",
      "📮",
      "🗳️",
      "✏️",
      "✒️",
      "🖋️",
      "🖊️",
      "🖌️",
      "🖍️",
      "📝",
      "💼",
      "📁",
      "📂",
      "🗂️",
      "📅",
      "📆",
      "🗒️",
      "🗓️",
      "📇",
      "📈",
      "📉",
      "📊",
      "📋",
      "📌",
      "📍",
      "📎",
      "🖇️",
      "📏",
      "📐",
      "✂️",
      "🗃️",
      "🗄️",
      "🗑️",
      "🔒",
      "🔓",
      "🔏",
      "🔐",
      "🔑",
      "🗝️",
      "🔨",
      "🪓",
      "⛏️",
      "⚒️",
      "🛠️",
      "🗡️",
      "⚔️",
      "💣",
      "🪃",
      "🏹",
      "🛡️",
      "🪚",
      "🔧",
      "🪛",
      "🔩",
      "⚙️",
      "🗜️",
      "⚖️",
      "🦯",
      "🔗",
      "⛓️",
      "🪝",
      "🧰",
      "🧲",
      "🪜",
      "⚗️",
      "🧪",
      "🧫",
      "🧬",
      "🔬",
      "🔭",
      "📡",
      "💉",
      "🩸",
      "💊",
      "🩹",
      "🩼",
      "🩺",
      "🩻",
      "🚪",
      "🛗",
      "🪞",
      "🪟",
      "🛏️",
      "🛋️",
      "🪑",
      "🚽",
      "🪠",
      "🚿",
      "🛁",
      "🪤",
      "🪒",
      "🧴",
      "🧷",
      "🧹",
      "🧺",
      "🧻",
      "🪣",
      "🧼",
      "🫧",
      "🪥",
      "🧽",
      "🧯",
      "🛒",
      "🚬",
      "⚰️",
      "🪦",
      "⚱️",
      "🧿",
      "🪬",
      "🪧",
      "🪪",
      "🏧",
      "🚮",
      "🚰",
      "♿",
      "🚹",
      "🚺",
      "🚻",
      "🚼",
      "🚾",
      "🛂",
      "🛃",
      "🛄",
      "🛅",
      "⚠️",
      "🚸",
      "⛔",
      "🚫",
      "🚳",
      "🚭",
      "🚯",
      "🚱",
      "🚷",
      "📵",
      "🔞",
      "☢️",
      "☣️",
      "⬆️",
      "↗️",
      "➡️",
      "↘️",
      "⬇️",
      "↙️",
      "⬅️",
      "↖️",
      "↕️",
      "↔️",
      "↩️",
      "↪️",
      "⤴️",
      "⤵️",
      "🔃",
      "🔄",
      "🔙",
      "🔚",
      "🔛",
      "🔜",
      "🔝",
      "🛐",
      "⚛️",
      "🕉️",
      "✡️",
      "☸️",
      "☯️",
      "✝️",
      "☦️",
      "☪️",
      "☮️",
      "🕎",
      "🔯",
      "🪯",
      "♈",
      "♉",
      "♊",
      "♋",
      "♌",
      "♍",
      "♎",
      "♏",
      "♐",
      "♑",
      "♒",
      "♓",
      "⛎",
      "🔀",
      "🔁",
      "🔂",
      "▶️",
      "⏩",
      "⏭️",
      "⏯️",
      "◀️",
      "⏪",
      "⏮️",
      "🔼",
      "⏫",
      "🔽",
      "⏬",
      "⏸️",
      "⏹️",
      "⏺️",
      "⏏️",
      "🎦",
      "🔅",
      "🔆",
      "📶",
      "🛜",
      "📳",
      "📴",
      "♀️",
      "♂️",
      "⚧️",
      "✖️",
      "➕",
      "➖",
      "➗",
      "🟰",
      "♾️",
      "‼️",
      "⁉️",
      "❓",
      "❔",
      "❕",
      "❗",
      "〰️",
      "💱",
      "💲",
      "⚕️",
      "♻️",
      "⚜️",
      "🔱",
      "📛",
      "🔰",
      "⭕",
      "✅",
      "☑️",
      "✔️",
      "❌",
      "❎",
      "➰",
      "➿",
      "〽️",
      "✳️",
      "✴️",
      "❇️",
      "©️",
      "®️",
      "™️",
      "#️⃣",
      "*️⃣",
      "0️⃣",
      "1️⃣",
      "2️⃣",
      "3️⃣",
      "4️⃣",
      "5️⃣",
      "6️⃣",
      "7️⃣",
      "8️⃣",
      "9️⃣",
      "🔟",
      "🔠",
      "🔡",
      "🔢",
      "🔣",
      "🔤",
      "🅰️",
      "🆎",
      "🅱️",
      "🆑",
      "🆒",
      "🆓",
      "ℹ️",
      "🆔",
      "Ⓜ️",
      "🆕",
      "🆖",
      "🅾️",
      "🆗",
      "🅿️",
      "🆘",
      "🆙",
      "🆚",
      "🈁",
      "🈂️",
      "🈷️",
      "🈶",
      "🈯",
      "🉐",
      "🈹",
      "🈚",
      "🈲",
      "🉑",
      "🈸",
      "🈴",
      "🈳",
      "㊗️",
      "㊙️",
      "🈺",
      "🈵",
      "🔴",
      "🟠",
      "🟡",
      "🟢",
      "🔵",
      "🟣",
      "🟤",
      "⚫",
      "⚪",
      "🟥",
      "🟧",
      "🟨",
      "🟩",
      "🟦",
      "🟪",
      "🟫",
      "⬛",
      "⬜",
      "◼️",
      "◻️",
      "◾",
      "◽",
      "▪️",
      "▫️",
      "🔶",
      "🔷",
      "🔸",
      "🔹",
      "🔺",
      "🔻",
      "💠",
      "🔘",
      "🔳",
      "🔲",
      "🏁",
      "🚩",
      "🎌",
      "🏴",
      "🏳️",
      "🏴‍☠️",
]
